// extracted by mini-css-extract-plugin
module.exports =  {"head":"head--j7Big","body":"body--pe9ma","footer":"footer--VEwCF","close-btn":"close-btn--nMdVR","closeBtn":"close-btn--nMdVR"};